import OptimizationCaseTaskEditDto from './OptimizationCaseTaskEditDto';

export class OptimizersComparisonTaskEditDto extends OptimizationCaseTaskEditDto {
    constructor() {
        super();

        /** @type {number[]} */
        this.optimizers = [];
    }

    /**
     * @typedef {Object} _OptimizersComparisonTaskEditDtoProps
     * @property {number[]} optimizers
     *
     * @typedef {import("./OptimizationCaseTaskEditDto").OptimizationCaseTaskEditDtoProps & _OptimizersComparisonTaskEditDtoProps} OptimizersComparisonTaskEditDtoProps
     */

    /**
     * 
     * @param {OptimizersComparisonTaskEditDtoProps} props
     * @returns {OptimizersComparisonTaskEditDto}
     */

    setup(props) {
        super.setup(props);

        this.optimizers = Array.isArray(props.optimizers) ? props.optimizers : [];

        return this;
    }
}

export default OptimizersComparisonTaskEditDto;